<template>
  <Button label="Back" severity="surface" icon="pi pi-arrow-left" iconPos="left"></Button>
</template>

<script setup lang="ts"></script>
